$header_close_height: 45;

:host {
  display: block;
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: $z-index-globa;

  &.fullscreen {
    bottom: 0;
    right: 0;
    height: var(--sofia-device-height-px);
    width: var(--sofia-device-width-px);
  }

  .chat-floating {
    display: flex;
    align-items: end;

    &.openTop {
      flex-direction: column;

      .chat-bubble {
        margin-top: 10px;
      }
    }

    &.openLeft {
      flex-direction: row;

      .chat-bubble {
        margin-left: 10px;
      }
    }

    // Globa
    .chat-bubble {
      color: var(--color-white);
      background-color: var(--brand-primary-2);
      transition: all 0.3s ease;
      display: none;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      overflow: hidden;

      &:hover {
        transform: scale(1.1);
      }

      .image {
        width: inherit;
        height: inherit;
        cursor: pointer;
      }
    }

    // Contenedor de header + chat
    .chat-header-content-wrapper {
      background-color: var(--color-white);
      border-radius: 10px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      display: none;
      transform: scale(0);
      transform-origin: bottom right;
      transition: transform 0.3s ease;
      flex-direction: column;
      overflow: hidden;

      &.withoutRadius {
        border-radius: 0;
      }

      &.open {
        display: flex;
        transform: scale(1);
      }

      // Header close
      .chat-header-closing {
        height: #{$header_close_height}px;
        display: flex;
        align-items: center;
        justify-content: end;
        padding: 0 20px;
        background-color: var(--color-white);
        width: 100%;
        box-sizing: border-box;

        .chat-close {
          cursor: pointer;
          color: black;
        }
      }

      // Chat container
      .chat-container {
        overflow: hidden;
        position: relative;
        right: 0;

        .terms-conditions-container {
          padding: 20px;
          bottom: 0;
          position: absolute;
          background-color: white;
          box-sizing: border-box;
          height: 100%;
          overflow-y: scroll;
          z-index: $z-index-terms-and-conditions-globa;
        }

        &.fullscreen {
          box-sizing: border-box;
          height: calc(var(--sofia-device-height-px) - #{$header_close_height}px);
          width: var(--sofia-device-width-px);
        }
      }
    }
  }
}
